<template>
  <v-container fluid>
    <h1 class="text-center">(404) Page NotFound</h1>
  </v-container>
</template>

<script>
export default {};
</script>